export const INTERNAL_RENDER_FAILURE_MESSAGE =
  "The report could not be prepared. Try again.";

export type InternalRenderFailureReason =
  | "pagination"
  | "report-attachment"
  | "report-photo"
  | "unknown";

export function signalInternalRenderFailure(
  reason: InternalRenderFailureReason = "unknown"
): string {
  document.documentElement.dataset.renderError = "true";
  const currentReason = document.documentElement.dataset.renderErrorReason as
    | InternalRenderFailureReason
    | undefined;
  if (!currentReason || reason !== "unknown") {
    document.documentElement.dataset.renderErrorReason = reason;
  }
  return INTERNAL_RENDER_FAILURE_MESSAGE;
}

export function clearInternalRenderFailure(): void {
  delete document.documentElement.dataset.renderError;
  delete document.documentElement.dataset.renderErrorReason;
}
